import React, { useState } from 'react';
import {
  IconButton,
  Tooltip,
  Box,
  Typography,
  ClickAwayListener
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const QuestionTooltip = ({ description }) => {
  const [open, setOpen] = useState(false);

  const handleTooltipToggle = () => {
    setOpen((prev) => !prev);
  };

  const handleClickAway = () => {
    if (open) {
      setOpen(false);
    }
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Box component="span">
        <Tooltip
          arrow
          placement="right"
          open={open}
          onClose={() => setOpen(false)}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={
            <Box sx={{ maxWidth: 300 }}>
              {description.split('\n').map((line, index) => {
                const [title, ...rest] = line.split('-');
                return (
                  <Typography variant="body2" sx={{ mb: 0.5 }} key={index}>
                    <strong>{title.trim()}</strong> - {rest.join('-').trim()}
                  </Typography>
                );
              })}
            </Box>
          }
        >
          <IconButton size="small" sx={{ p: 0.5 }} onClick={handleTooltipToggle}>
            <InfoOutlinedIcon fontSize="small" color="action" />
          </IconButton>
        </Tooltip>
      </Box>
    </ClickAwayListener>
  );
};

export default QuestionTooltip;
